import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Card, { CardBody } from '../../bootstrap/Card';

interface StudentFeeCardsProps {
	studentTotalFeeCollectionData: any[];
}

const StudentFeeCards: React.FC<StudentFeeCardsProps> = ({ studentTotalFeeCollectionData }) => {
	const { darkModeStatus } = useDarkMode();

	if (!studentTotalFeeCollectionData || studentTotalFeeCollectionData.length === 0) {
		return null;
	}

	return (
		<>
			{studentTotalFeeCollectionData.map((studentTotalFee: any) => (
				<div className='row g-4 mb-4' key={studentTotalFee.studentDetailsId}>
					{/* TOTAL CARD */}
					<div className='col-md-3'>
						<Card
							className={`bg-l${darkModeStatus ? 'o25' : '25'}-primary bg-l${
								darkModeStatus ? 'o50' : '10'
							}-primary-hover transition-base rounded-2 mb-0`}
							shadow='sm'>
							<CardBody>
								<div className='d-flex align-items-center pb-3'>
									<div className='ratio ratio-1x1 me-3' style={{ width: 48 }}>
										<div
											className={classNames(
												'rounded-5',
												'd-flex align-items-center justify-content-center',
												'bg-primary',
											)}>
											<span className='avatar-1 fs-3 text-white fw-bold'>T</span>
										</div>
									</div>
									<div className='flex-grow-1 ms-3'>
										<div className='fw-bold fs-3 text-primary mb-0'>
											₹{studentTotalFee.semFees_grossPayable +
												studentTotalFee.busFees_grossPayable +
												studentTotalFee.prevSemFees_netPayable +
												studentTotalFee.prevBusFees_netPayable +
												studentTotalFee.extraFees_grossPayable +
												studentTotalFee.prevExtraFees_netPayable}
										</div>
										<div className='text-muted'>
											<b> TOTAL - {studentTotalFee.semesterNumber}</b>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
					</div>

					{/* PAID CARD */}
					<div className='col-md-3'>
						<Card
							className={`bg-l${darkModeStatus ? 'o25' : '25'}-success bg-l${
								darkModeStatus ? 'o50' : '10'
							}-success-hover transition-base rounded-2 mb-0`}
							shadow='sm'>
							<CardBody>
								<div className='d-flex align-items-center pb-3'>
									<div className='ratio ratio-1x1 me-3' style={{ width: 48 }}>
										<div
											className={classNames(
												'rounded-5',
												'd-flex align-items-center justify-content-center',
												'bg-success',
											)}>
											<span className='avatar-1 fs-3 text-white fw-bold'>P</span>
										</div>
									</div>
									<div className='flex-grow-1 ms-3'>
										<div className='fw-bold fs-3 text-success mb-0'>
											₹ {studentTotalFee.semFees_amountPaid +
												studentTotalFee.semFees_concession +
												studentTotalFee.busFees_amountPaid +
												studentTotalFee.busFees_concession +
												studentTotalFee.extraFees_amountPaid +
												studentTotalFee.extraFees_concession}
										</div>
										<div className='text-muted'>
											<b>PAID</b>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
					</div>

					{/* BALANCE CARD */}
					<div className='col-md-3'>
						<Card
							className={`bg-l${darkModeStatus ? 'o25' : '25'}-danger bg-l${
								darkModeStatus ? 'o50' : '10'
							}-danger-hover transition-base rounded-2 mb-0`}
							shadow='sm'>
							<CardBody>
								<div className='d-flex align-items-center pb-3'>
									<div className='ratio ratio-1x1 me-3' style={{ width: 48 }}>
										<div
											className={classNames(
												'rounded-5',
												'd-flex align-items-center justify-content-center',
												'bg-danger',
											)}>
											<span className='avatar-1 fs-3 text-white fw-bold'>B</span>
										</div>
									</div>
									<div className='flex-grow-1 ms-3'>
										<div className='fw-bold fs-3 text-danger mb-0'>
											₹ {studentTotalFee.semFees_netPayable +
												studentTotalFee.prevSemFees_netPayable +
												studentTotalFee.busFees_netPayable +
												studentTotalFee.prevBusFees_netPayable +
												studentTotalFee.extraFees_netPayable}
										</div>
										<div className='text-muted'>
											<b> BALANCE</b>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
					</div>

					{/* FINE CARD */}
					<div className='col-md-3'>
						<Card
							className={`bg-l${darkModeStatus ? 'o25' : '25'}-warning bg-l${
								darkModeStatus ? 'o50' : '10'
							}-warning-hover transition-base rounded-2 mb-0`}
							shadow='sm'>
							<CardBody>
								<div className='d-flex align-items-center pb-3'>
									<div className='ratio ratio-1x1 me-3' style={{ width: 48 }}>
										<div
											className={classNames(
												'rounded-5',
												'd-flex align-items-center justify-content-center',
												'bg-warning',
											)}>
											<span className='avatar-1 fs-3 text-white fw-bold'>F</span>
										</div>
									</div>
									<div className='flex-grow-1 ms-3'>
										<div className='fw-bold fs-3 text-warning mb-0'>
											₹ {studentTotalFee.totalFineAmount}
										</div>
										<div className='text-muted'>
											<b>FINE</b>
										</div>
									</div>
								</div>
							</CardBody>
						</Card>
					</div>
				</div>
			))}
		</>
	);
};

export default StudentFeeCards;
